export default __webpack_public_path__ + "static/media/frame2.d41469e2.png";